<immo-header-navigation-desktop
  [attr.data-layout-bp]="breakpoint"
  class="hidden! layout-bp:block!"
  [navigation]="navigation()"
/>
<immo-header-navigation-mobile
  [attr.data-layout-bp]="breakpoint"
  class="layout-bp:hidden!"
  [navigation]="navigation()"
/>
